import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_vexly-landing/artifacts/tuan08x2_VEXLY%20APP.jpg";

// VexlyPOS official logo — uses the real artwork with an SVG color-matrix
// filter that knocks the white background to transparent so the V mark
// floats cleanly on the dark theme. The mark is cropped to hide the
// wordmark inside the JPG; we render our own "VexlyPOS" wordmark in white.
export const Logo = ({ size = 44, withText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="vexly-logo">
      <span
        className="relative block overflow-hidden"
        style={{ width: size, height: size }}
        aria-label="VexlyPOS logo"
      >
        <img
          src={LOGO_URL}
          alt="VexlyPOS"
          style={{
            position: "absolute",
            width: size * 2.8,
            height: size * 2.8,
            left: "50%",
            top: "50%",
            // V mark center sits at ~45% of the image height (the bottom of
            // the image is the "VexlyPOS" wordmark we don't want to show).
            // Shift the image DOWN slightly so the V mark lands in the box.
            transform: `translate(-50%, calc(-50% + ${size * 0.14}px))`,
            objectFit: "contain",
            maxWidth: "none",
            filter: "url(#vexly-knockout)",
          }}
        />
      </span>
      {withText && (
        <span
          className="font-heading font-bold tracking-tight text-white leading-none"
          style={{ fontSize: size * 0.55 }}
        >
          Vexly<span className="text-brand-orange">POS</span>
        </span>
      )}
    </div>
  );
};

// Full official logo (used in hero/CTA where we want the complete branded artwork)
export const LogoFull = ({ size = 120, className = "" }) => {
  return (
    <span className={`inline-block ${className}`} data-testid="vexly-logo-full">
      <img
        src={LOGO_URL}
        alt="VexlyPOS"
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          filter: "url(#vexly-knockout)",
        }}
      />
    </span>
  );
};

// Drop this once at the root of the app — provides the SVG filter that
// converts the JPG's white background into transparency.
export const LogoFilterDefs = () => (
  <svg
    width="0"
    height="0"
    aria-hidden="true"
    style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
  >
    <defs>
      <filter id="vexly-knockout" colorInterpolationFilters="sRGB">
        {/* alpha = clamp(-R - G - B + 3A) → white(1,1,1)=0 transparent,
            colors stay visible. Slightly boost saturation to keep orange punchy. */}
        <feColorMatrix
          type="matrix"
          values="1 0 0 0 0
                  0 1 0 0 0
                  0 0 1 0 0
                  -1 -1 -1 3 0"
        />
      </filter>
    </defs>
  </svg>
);

export default Logo;

